<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7KKhLp/cover.jpeg?1684514593892" alt="This image is the cover for the book The Thirteenth Princess, Volume 6"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Thirteenth Princess, Volume 6
      </h1>
      <p class="bookDescription body article font2">
        <p>Duan Yunfei never expected that a dignified female hero like him would marry a jealous man. Even if he were to meet the Western Lion Protector out of respect, it would still cause him to go into a rage of jealousy."Mu Xianyang, this princess has said that I have business with him. If you dare to be jealous again, this princess will throw you into a bathtub of vinegar."Mu Xianyang almost died of anger when he heard this, "Thirteenth Princess, you were born to this king, and death belongs to this king. Even if you end up taking a bath in a jar of vinegar, you have to accompany me."One day, in order to prove that he loved Duan Yunfei, Mu Xianyang had someone prepare a jar of vinegar and was about to pull Duan Yunfei to take a bath. The corner of Duan Yunfei's lips slightly raised as he thought to himself, 'Mu Xianyang, you really are a cute kid.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Feng Xiangpianbei, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e632a790